import React from 'react';
import * as Icons from 'lucide-react';
import { Asterisk, ArrowUpRight } from 'lucide-react';
import { industries } from '../data/mock';

const Industries = () => {
  return (
    <section id="industries" className="relative py-20 lg:py-28 bg-[#FFF8EC]/40">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-14 items-end">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-2 text-sm font-medium text-[#C41E3A] mb-4">
              <Asterisk className="w-4 h-4" /> Industries We Serve
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-[3.5rem] font-extrabold text-neutral-900 leading-[1.05]">
              Compliance coverage across regulated categories
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-neutral-600 text-base md:text-lg leading-relaxed mb-6">
              From electronics and telecom to medical devices, automotive, construction materials and industrial products — mapped to the right regulator and testing pathway.
            </p>
            <div className="flex gap-8">
              <div>
                <div className="font-display text-3xl font-extrabold text-neutral-900">12+</div>
                <div className="text-xs text-neutral-500 uppercase tracking-widest mt-1">Segments</div>
              </div>
              <div>
                <div className="font-display text-3xl font-extrabold text-neutral-900">20+</div>
                <div className="text-xs text-neutral-500 uppercase tracking-widest mt-1">Pathways</div>
              </div>
              <div>
                <div className="font-display text-3xl font-extrabold text-[#C41E3A]">1</div>
                <div className="text-xs text-neutral-500 uppercase tracking-widest mt-1">Managed desk</div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {industries.map((ind) => {
            const Icon = Icons[ind.icon] || Icons.Circle;
            return (
              <div
                key={ind.id}
                className="lift group relative bg-white border border-neutral-200 rounded-[1.5rem] p-6 hover:bg-[#0A0E1A] hover:border-[#0A0E1A] transition-all duration-500 cursor-pointer overflow-hidden"
              >
                <div className="flex items-start justify-between mb-8">
                  <span className="w-14 h-14 rounded-2xl bg-rose-50 group-hover:bg-[#C41E3A] flex items-center justify-center transition-colors">
                    <Icon className="w-6 h-6 text-[#C41E3A] group-hover:text-white transition-colors" />
                  </span>
                  <span className="text-[10px] font-mono text-neutral-400 group-hover:text-[#F87171] transition-colors">/ {ind.id}</span>
                </div>
                <h3 className="font-display text-xl font-bold text-neutral-900 group-hover:text-white transition-colors mb-2">{ind.name}</h3>
                <p className="text-xs text-neutral-500 group-hover:text-white/60 leading-relaxed transition-colors mb-4">{ind.desc}</p>
                <div className="flex items-center gap-1.5 text-xs font-semibold text-[#C41E3A] group-hover:text-[#F87171] transition-colors">
                  Learn more
                  <ArrowUpRight className="w-3.5 h-3.5 group-hover:rotate-45 transition-transform" />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;
